export const focusBySiteColumnDefinitions = [
    {
        field: 'domain',
        hide: true,
        rowGroup: true
    },
    {
        field: 'userName',
        headerName: 'Site',
        filter: 'agTextColumnFilter',
        cellRenderer: 'agGroupCellRenderer',
        cellRendererParams: { suppressCount: true },
        showRowGroup: true
    },
    {
        headerName: 'Workload',
        field: 'isProductive',
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        aggFunc: (params: any) => {
            const returnValue = params.values[0] && params.values[0] === 'Yes' ? 'Yes' : 'No';
            return returnValue;
        }
    },
    {
        headerName: 'Active Time',
        field: 'workEffortSecs',
        filter: 'agNumberColumnFilter',
        aggFunc: 'sum',
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        valueFormatter: (params: any) => {
            return toTimeStamp(params.value);
        }
    },
    {
        headerName: 'Count',
        field: 'count',
        filter: 'agNumberColumnFilter',
        aggFunc: 'sum'

    },
    {
        headerName: 'Idle Time',
        field: 'idleTimeSecs',
        filter: 'agNumberColumnFilter',
        aggFunc: 'sum',
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        valueFormatter: (params: any) => {
            return toTimeStamp(params.value);
        }

    }
];

export const focusByTeamColumnDefinitions = [
    {
        field: 'teamName',
        hide: true,
        rowGroup: true
    },
    {
        field: 'userName',
        filter: 'agTextColumnFilter',
        headerName: 'Teams',
        showRowGroup: true,
        cellRenderer: 'agGroupCellRenderer',
        cellRendererParams: { suppressCount: true }
    },
    {
        headerName: 'Total',
        children: [
            {
                field: 'totalWorkEffortSecs',
                headerName: 'Active Time',
                filter: 'agNumberColumnFilter',
                aggFunc: 'sum',
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                valueFormatter: (params: any) => {
                    return toTimeStamp(params.value);
                }
            },
            {
                field: 'totalCount',
                headerName: 'Count',
                filter: 'agNumberColumnFilter',
                aggFunc: 'sum'
            },
            {
                field: 'totalIdleTimeSecs',
                headerName: 'Idle Time',
                filter: 'agNumberColumnFilter',
                aggFunc: 'sum',
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                valueFormatter: (params: any) => {
                    return toTimeStamp(params.value);
                }
            }
        ]
    },
    {
        headerName: 'Workload',
        children: [
            {
                field: 'workloadWorkEffortSecs',
                headerName: 'Active Time',
                filter: 'agNumberColumnFilter',
                aggFunc: 'sum',
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                valueFormatter: (params: any) => {
                    return toTimeStamp(params.value);
                }
            },
            {
                field: 'workloadCount',
                headerName: 'Count',
                filter: 'agNumberColumnFilter',
                aggFunc: 'sum'
            },
            {
                field: 'workloadIdleTimeSecs',
                headerName: 'Idle Time',
                filter: 'agNumberColumnFilter',
                aggFunc: 'sum',
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                valueFormatter: (params: any) => {
                    return toTimeStamp(params.value);
                }
            }
        ]
    },  {
        headerName: 'Other',
        children: [
            {
                field: 'otherWorkEffortSecs',
                headerName: 'Active Time',
                filter: 'agNumberColumnFilter',
                aggFunc: 'sum',
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                valueFormatter: (params: any) => {
                    return toTimeStamp(params.value);
                }
            },
            {
                field: 'otherCount',
                headerName: 'Count',
                filter: 'agNumberColumnFilter',
                aggFunc: 'sum'
            },
            {
                field: 'otherIdleTimeSecs',
                headerName: 'Idle Time',
                filter: 'agNumberColumnFilter',
                aggFunc: 'sum',
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                valueFormatter: (params: any) => {
                    return toTimeStamp(params.value);
                }
            }
        ]
    }
];

const toTimeStamp = (value: number | string) => {
    let seconds = value;
    if (typeof seconds === 'string') {
        seconds = parseInt(seconds, 10);
    }
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    const formattedHours = String(hours).padStart(2, '0');
    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(remainingSeconds).padStart(2, '0');

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};